export enum EmailType {
  Confirmation = 'confirmation',
  Welcome = 'welcome',
  ResetPassword = 'reset-password',
  PaymentFailed = 'payment-failed',
  PaymentSuccess = 'payment-success',
  GetStartedAfterSubscribe = 'get-started-after-subscribe',
  VideoRendered = 'video-rendered',
  SocialAccountReconnect = 'social-account-reconnect',
  SeriesDisabled = 'series-disabled',
  LowCredits = 'low-credits',
  NoCredits = 'no-credits',
  FirstVideoCreated = 'first-video-created',
}

// Email types that users can configure
export enum ConfigurableEmailType {
  VideoRendered = EmailType.VideoRendered,
  SeriesDisabled = EmailType.SeriesDisabled,
  LowCredits = EmailType.LowCredits,
  NoCredits = EmailType.NoCredits,
  SocialAccountReconnect = EmailType.SocialAccountReconnect,
}

export const DEFAULT_EMAIL_NOTIFICATIONS: Record<
  ConfigurableEmailType,
  boolean
> = {
  [ConfigurableEmailType.VideoRendered]: true,
  [ConfigurableEmailType.SeriesDisabled]: true,
  [ConfigurableEmailType.LowCredits]: true,
  [ConfigurableEmailType.NoCredits]: true,
  [ConfigurableEmailType.SocialAccountReconnect]: true,
};

export enum EmailProvider {
  RESEND = 'resend',
}

export interface SendMailOptions {
  to: string;
  provider?: EmailProvider;
  type: EmailType;
  params?: {
    addBaseUrl?: boolean;
    url?: string;
    amount?: string;
    date?: string;
    userName?: string;
    tutorialLink?: string;
    title?: string;
    socialProvider?: string;
    socialAccountName?: string;
    seriesTitle?: string;
    creditsRemaining?: number;
    planName?: string;
  };
}
